'use client';

import { c as _c } from "react/compiler-runtime";
import { useEffect } from 'react';
import { useRouter, usePathname } from 'next/navigation';
import { useSession } from 'next-auth/react';
import AccountLoadingSkeleton from './AccountLoadingSkeleton';

/**
 * Client-side auth guard for account pages.
 * Uses NextAuth's useSession() directly for auth state.
 * Redirects to login when not authenticated.
 */
const AccountAuthGuard = t0 => {
  const $ = _c(9);
  const {
    children
  } = t0;
  const router = useRouter();
  const pathname = usePathname();
  const {
    status
  } = useSession();
  let t1;
  if ($[0] !== pathname) {
    const publicRoutes = ["/account/login", "/account/new", "/account/lost_pass", "/account/reset-password", "/account/create", "/account/communication-preferences", "/favorites"];
    t1 = pathname && publicRoutes.some(route => pathname.startsWith(route));
    $[0] = pathname;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const isPublicRoute = t1;
  const isProtectedAccountRoute = pathname && pathname.startsWith("/account") && !isPublicRoute;
  let t2;
  let t3;
  if ($[2] !== isPublicRoute || $[3] !== router || $[4] !== status) {
    t2 = () => {
      if (isPublicRoute) {
        return;
      }
      if (status === "unauthenticated") {
        router.push("/account/login");
      }
    };
    t3 = [status, router, isPublicRoute];
    $[2] = isPublicRoute;
    $[3] = router;
    $[4] = status;
    $[5] = t2;
    $[6] = t3;
  } else {
    t2 = $[5];
    t3 = $[6];
  }
  useEffect(t2, t3);
  if (isPublicRoute) {
    return children;
  }
  if (isProtectedAccountRoute && status === "loading") {
    let t4;
    if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
      t4 = <AccountLoadingSkeleton />;
      $[7] = t4;
    } else {
      t4 = $[7];
    }
    return t4;
  }
  if (isProtectedAccountRoute && status === "unauthenticated") {
    let t4;
    if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
      t4 = <AccountLoadingSkeleton />;
      $[8] = t4;
    } else {
      t4 = $[8];
    }
    return t4;
  }
  return children;
};
export default AccountAuthGuard;